import React from 'react';
import {
  Flex,
  useColorMode,
  Text,
  color,
  typography,
  BookIconSvg,
  LibrarySvg,
  PhoneSvg,
  HeadphonesSvg,
  StashedSvg,
  useIsMobileView,
} from 'deepstash-ui';
import LandingStartTrialButton from 'src/page-components/landing/components-v2/LandingStartTrialButton';

const TITLE = "What's in every Deepstash membership?";

interface CollectionSubscriptionSectionProps {}

const CollectionSubscriptionSection: React.FC<
  CollectionSubscriptionSectionProps
> = ({}) => {
  const isMobileView = useIsMobileView();
  const { colorMode } = useColorMode();

  return (
    <Flex
      flexDirection={isMobileView ? 'column' : 'row'}
      width={'100%'}
      gridColumnGap={32}
      mt={isMobileView ? 32 : 128}
      {...(isMobileView
        ? { alignItems: 'center', gridRowGap: 32, px: 16 }
        : {})}
    >
      <Flex flex={1} flexDirection="column" justifyContent="center">
        <Text
          {...(isMobileView
            ? typography.primaryHeadingFonts.large.bold
            : typography.primaryHeadingFonts.xl.bold)}
          color={color[colorMode].text}
          {...(isMobileView ? { textAlign: 'center' } : {})}
        >
          {TITLE}
        </Text>
      </Flex>
      <Flex
        flex={0.9}
        flexDirection="column"
        justifyContent="center"
        gridRowGap={16}
      >
        <Flex flexDirection="row" alignItems="center" gridColumnGap={4}>
          <BookIconSvg color={color[colorMode].text} />
          <Text
            {...typography.primaryHeadingFonts.small.regular}
            color={color[colorMode].text}
          >
            {'Key ideas from 1,000+ books'}
          </Text>
        </Flex>
        <Flex flexDirection="row" alignItems="center" gridColumnGap={4}>
          <LibrarySvg color={color[colorMode].text} />
          <Text
            {...typography.primaryHeadingFonts.small.regular}
            color={color[colorMode].text}
          >
            {'Access to 200,000+ ideas'}
          </Text>
        </Flex>
        <Flex flexDirection="row" alignItems="center" gridColumnGap={4}>
          <PhoneSvg color={color[colorMode].text} />
          <Text
            {...typography.primaryHeadingFonts.small.regular}
            color={color[colorMode].text}
          >
            {'Personalized recommendations'}
          </Text>
        </Flex>
        <Flex flexDirection="row" alignItems="center" gridColumnGap={4}>
          <HeadphonesSvg color={color[colorMode].text} />
          <Text
            {...typography.primaryHeadingFonts.small.regular}
            color={color[colorMode].text}
          >
            {'Listen instead of reading'}
          </Text>
        </Flex>
        <Flex flexDirection="row" alignItems="center" gridColumnGap={4}>
          <StashedSvg color={color[colorMode].text} />
          <Text
            {...typography.primaryHeadingFonts.small.regular}
            color={color[colorMode].text}
          >
            {'Build your knowledge library'}
          </Text>
        </Flex>
        <Flex flexDirection="row">
          <LandingStartTrialButton
            landingLocation={'collection-membership'}
            mt={16}
            width={isMobileView ? '100%' : '70%'}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default CollectionSubscriptionSection;
